import { UPDATE_PROFFIT_SEARCH_DEVICE } from '../actions/ProffitSearchDeviceAction';
import { STORAGE_USER_DEVICE } from '../define/const';
import webStorage from '../helpers/webStorage';
const INITIAL_STATE = {
    userDevice: webStorage.get(STORAGE_USER_DEVICE),
};
// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, { payload, type }) => {
    switch (type) {
        case UPDATE_PROFFIT_SEARCH_DEVICE: {
            return Object.assign(Object.assign({}, state), { userDevice: payload });
        }
        default: {
            return state;
        }
    }
};
